<template>
  <lottie
    v-if="src && animationData"
    :options="{
      animationData: animationData,
      ...options
    }"
  />
</template>

<script>
import lottie from 'vue-lottie'
import axios from 'axios'

export default {
  props: ['src', 'options'],
  components: { lottie },
  data() {
    return {
      animationData: null
    }
  },
  async created() {
    const res = await axios.get(this.src)
    this.animationData = res.data
  }
}
</script>
